<template>
    <div class="solutions-card-with-button" v-if="data">
      <h3 class=solutions-card-with-button__title v-if="data?.title">{{ resource[data?.title] }}</h3>
        <div class="solutions-card-with-button__items">
            <SolutionsCardWithButtonItem v-for="(item, index) in data?.items" :key="index" :data="item"/>
        </div>
        <a v-if="data?.buttonUrl && data?.buttonText" :href="data?.buttonUrl" class="solutions-card-with-button__button">
          {{ resource[data?.buttonText] }}
        </a>
    </div>
</template>
<script>
import SolutionsCardWithButtonItem from './SolutionsCardWithButtonItem.vue';

export default {
  name: 'SolutionsCardWithButton',
  components: {
    SolutionsCardWithButtonItem,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/starter.scss";
.solutions-card-with-button {
  display: flex;
  padding: 16px 0px 16px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  margin: 0 auto;

  &__title {
    display: flex;
    width: 100%;
    justify-content: center;
    color: #353535;
    text-align: center;
    font-family: Ubuntu;
    font-size: 22px;
    font-weight: 500;
    line-height: 28px;
  }
  &__description {
    font-family: Ubuntu;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: #353535;
    text-align: center;
  }
  &__items {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: stretch;
    gap: 16px;
    align-self: stretch;
    flex-wrap: wrap;
    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      gap: 16px
    }
  }
  &__button {
    border-radius: 4px;
    width: 214px;
    padding: 8px 22px;
    background: #FF8D06 !important;
    color: #FFFFFF;
    text-decoration: none;
    font-family: Ubuntu;
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0.46px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    &:hover{
      background: #FF7415 !important;
    }
    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      width: 100%;
    }
  }

}
</style>
